import React from 'react';
import { MdMarkEmailUnread } from "react-icons/md";
import './footer.css';

const Footer = () => {
  return (
    <div id="contact">
      <a href="https://chat.whatsapp.com/C1tp2Fy8ErfDmdDJWRWVpH" aria-label="Join WhatsApp group">
        <img
          src="https://cdn-icons-png.flaticon.com/512/3670/3670051.png"
          className="whp"
          alt="WhatsApp"
        />
      </a>

      <footer>
        <div
          style={{
            background: '#efefef',
            padding: 20,
            textAlign: 'center',
            color: '#000c66',
            backdropFilter: 'blur(2px)',
          }}
        >
          <h2>Sivasundararaj R</h2>
          <p style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 5 }}>
            <MdMarkEmailUnread size={23} />
            codingwithssr@gmail.com
          </p>
          <p style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 5 }}>
            <MdMarkEmailUnread size={23} />
            siva.avis47@gmail.com
          </p>
        </div>

        <div className="sociallink" style={{ marginTop: 10 }}>
          <p>© Copyright @2025 codingwithssr All Rights Reserved</p>
          <p style={{ display: 'flex', justifyContent: 'space-between', width: 300, margin: '0 auto' }}>
            <a href="https://github.com/sivaraj47" className="ft">Github</a>
            <a href="https://codepen.io/codingwithssr" className="ft">Codepen</a>
            <a href="https://www.linkedin.com/in/sivasundararaj-r" className="ft">Linkedin</a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
